import React, {Component} from 'react'
import { Route, Switch, withRouter, Redirect } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import App from '../containers/App'
import Entry from '../containers/Entry'
import SalesManager from "containers/SalesManager"
import ARCInterface from "./ARCInterface"
import SuperintendentInterface from "./SuperintendentInterface"
import { getPayload, updateDates, updateCompareDates, compareStatus } from "actions"
import moment from 'moment'
import { compose } from "redux"


class Authenticated extends Component {
	constructor(props) {
		super(props)
		this.loadStoredDates()
		this.state = {
			status: false
		}

		if (localStorage.user) {
            var jwtDecode = require("jwt-decode")
            try {
                var user = jwtDecode(localStorage.user)
                //console.log(user)
                if (user.id > 0) {
					//this.setState({ status: true })
					this.state.status = true
                }
            } catch (e) {
                localStorage.removeItem("user")
                alert("An error has been encountered.  Please try again later.")
                //console.log(e)
            }
        }
	}

	loadStoredDates = () => {
		if(localStorage.getItem('currentDates')) {
			let data = JSON.parse(localStorage.getItem('currentDates'))
			let currentDates = {
				startDate: moment(data.startDate),
				endDate: moment(data.endDate)
			}
			if(data.ytd) {
				currentDates.endDate = moment()
			}
			this.props.updateDates(currentDates)
		}
		else {
            var currentDates = {
                startDate: moment().subtract(6, "months"),
                endDate: moment(),
            }
            this.props.updateDates(currentDates)
		}

		if(localStorage.getItem('compareDates')) {
			let dates = JSON.parse(localStorage.getItem('compareDates'))
			let compareDates =  {
				startDate: moment(dates.startDate),
				endDate: moment(dates.endDate),
			}
			this.props.updateCompareDates(compareDates)
			this.props.compareStatus(true)
		}
	}

	authenticated = () => {
		if(this.state.status) {
			return (
				<Switch>
					<Route render={this._authenticated} path="/entry" component={Entry} name="Entry" />
					<Route render={this._authenticated} path="/arc" component={ARCInterface} name="ARC" />
					<Route render={this._authenticated} path="/superintendent" component={SuperintendentInterface} name="Superintendent" />
					<Route
						render={this._authenticated}
						path="/salesManager"
						component={SalesManager}
						name="SalesManager"
					/>
					<Route render={this._authenticated} path="/" component={App} name="Home" />
				</Switch>
			)
		}
		else {
			return (<Redirect to="/login" />)
		}
	}


	render() {
		return (
			<div className="">
				{this.authenticated()}
			</div>
		)
	}
}

function mapStateToProps(state) {
    return {
		currentDates: state.currentDates,
		payload: state.payload,

    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
		{
			getPayload,
			updateDates,
			updateCompareDates,
			compareStatus,
		},
		dispatch
	)
}


export default withRouter(compose(connect(mapStateToProps, matchDispatchToProps))(Authenticated))


